import React from 'react'

const MonthEventContent = ({ patientRecord, service, recordData }) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'space-between' }}>AVAILABLE</div>
  )
}

export default MonthEventContent
